import React, { Component } from 'react';
import { Field, formValueSelector, reduxForm, reset } from 'redux-form';
import { renderCheckbox, renderInput } from 'src/components/misc/redux-form-helpers';
import DateTimePicker from 'src/components/misc/DateTimePicker';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { isBlank } from 'src/components/misc/validations';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { IconLabel } from 'src/components/administration/IconLabel';

class AdminOperatorSupportBillingOperatorAddTaskForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
        };
    }

    handleFormSubmit(values) {
        this.props.onSubmit(values); // if needed, but maybe redundant
        this.setState({ showForm: false });
    }

    render() {
        const { t, handleSubmit, selectedMonth } = this.props;
        const { showForm } = this.state;

        const currentMonth = moment.unix(parseInt(selectedMonth));

        const minDate = currentMonth.clone().startOf('month');
        const maxDate = currentMonth.clone().endOf('month');

        const isBillingMonth = moment.unix(selectedMonth).month() === moment().startOf('month').month();
        const { supportStarted, supportEnded } = this.props;
        let durationText = null;
        if (supportStarted && supportEnded) {
            const start = moment(supportStarted, 'DD.MM.YYYY HH:mm');
            const end = moment(supportEnded, 'DD.MM.YYYY HH:mm');

            if (start.isValid() && end.isValid()) {
                const durationTimeDiff = moment.duration(end.diff(start));
                const hours = Math.floor(durationTimeDiff.asHours());
                const minutes = durationTimeDiff.minutes();

                durationText = `${hours}h ${minutes}m`;
            }
        }

        return (
            <div>
                {isBillingMonth && (
                    <button
                        className="btn btn-xs btn-link btn-link-neutral"
                        style={{ marginBottom: 25 }}
                        onClick={() => {
                            this.setState({ showForm: true });
                        }}>
                        <IconLabel icon="plus" text={t('invoice.add_support_task')} />
                    </button>
                )}
                {showForm && isBillingMonth && (
                    <form className="form-horizontal" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                        <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="col-md-3">
                                <Field
                                    name="supportTaskDescription"
                                    label={`${t('invoice.description')} *`}
                                    component={renderInput}
                                />
                            </div>
                            <div className="col-md-3">
                                <Field
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    name="supportStarted"
                                    label={`${t('invoice.startedAt')} *`}
                                    hintText={t('invoice.startedAt')}
                                    component={DateTimePicker}
                                />
                            </div>
                            <div className="col-md-3">
                                <Field
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    name="supportEnded"
                                    label={`${t('invoice.endedAt')} *`}
                                    hintText={t('invoice.endedAt')}
                                    component={DateTimePicker}
                                />
                            </div>

                            {durationText && (
                                <div
                                    className="col-md-1"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-end',
                                        textAlign: 'right',
                                    }}>
                                    <span>
                                        {' '}
                                        berechnet: <strong>{durationText}</strong>{' '}
                                    </span>
                                </div>
                            )}
                            <div className="col-md-2">
                                <RaisedButton primary={true} type="submit" label={t('invoice.add')} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3"></div>
                            <div className="col-md-3">
                                {' '}
                                <Field name="hideTime" component={renderCheckbox} label={t('invoice.hide_time')} />
                            </div>
                        </div>
                    </form>
                )}
            </div>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    if (isBlank(values.supportTaskDescription)) errors.supportTaskDescription = t('error_missing.fill_in_description');
    if (isBlank(values.supportStarted)) errors.supportStarted = t('error_missing.fill_in_start');
    if (isBlank(values.supportEnded)) errors.supportEnded = t('error_missing.fill_in_end');
    if (moment(values.supportStarted, 'DD/MM/YYYY HH:mm:ss') >= moment(values.supportEnded, 'DD/MM/YYYY HH:mm:ss'))
        errors.supportStarted = t('error_hint.endtime_smaller_start');
    const start = moment(values.supportStarted, 'DD/MM/YYYY HH:mm:ss');
    const end = moment(values.supportEnded, 'DD/MM/YYYY HH:mm:ss');

    const billingPeriod = moment().startOf('month').month();
    const isBillingMonth = start.month() === billingPeriod && end.month() === billingPeriod;
    if (start.isValid() && end.isValid() && !isBillingMonth) {
        errors.supportStarted = t('error_hint.not_within_billing_period');
        errors.supportEnded = t('error_hint.not_within_billing_period');
    }
    return errors;
};

const selector = formValueSelector('adminOperatorSupportBillingOperatorAddTaskForm');

const mapStateToProps = state => ({
    initialValues: {
        supportStarted: moment().format('DD.MM.YYYY HH:mm'),
        supportEnded: moment().add(1, 'hour').format('DD.MM.YYYY HH:mm'),
    },
    supportStarted: selector(state, 'supportStarted'),
    supportEnded: selector(state, 'supportEnded'),
    hideForm: state.showForm,
});

AdminOperatorSupportBillingOperatorAddTaskForm = reduxForm({
    form: 'adminOperatorSupportBillingOperatorAddTaskForm',
    validate,
    onSubmitSuccess(result, dispatch, props) {
        dispatch(reset('adminOperatorSupportBillingOperatorAddTaskForm'));
    },
})(AdminOperatorSupportBillingOperatorAddTaskForm);

export default withTranslation()(connect(mapStateToProps)(AdminOperatorSupportBillingOperatorAddTaskForm));
